<template>
  <div>
    <div class="application6">
      <div class="bannerTemp">
        <bannerTemp :data="bannerData"></bannerTemp>
      </div>
      <module1 :data="a"></module1>
      <module1 :data="b"></module1>
      <module1 :data="c" style="margin-bottom:150px;">
        <div slot="content">
          <img src="../../assets/images/application/application6-1.jpg" alt />
          <img src="../../assets/images/application/application6-2.jpg" alt />
          <img src="../../assets/images/application/application6-3.jpg" alt />
          <img src="../../assets/images/application/application6-4.jpg" alt />
          <img src="../../assets/images/application/application6-5.jpg" alt />
          <img src="../../assets/images/application/application6-6.jpg" alt />
        </div>
      </module1>
    </div>
    <div class="mobile-application6">
      <div class="mobile-bannerTemp">
        <bannerTemp :data="bannerData" :isLong="true"></bannerTemp>
      </div>
      <div class="content">
        <div class="range">
          <div class="part-title">
            业务应用范围
          </div>
          <div class="part-content">
            <p>公安指挥调度系统、城市应急管理系统、重大事件安保系统、安全生产应急管理系统等。</p>
          </div>
        </div>
        <div class="range">
          <div class="part-title">
            业务应用概述
          </div>
          <div class="part-content">
            <p>可视化应急指挥系统是基于先进GIS地理信息系统、GPS全球定位系统、RS遥感遥测系统、无线通讯系统、电视会议系统等和应急信息资源的多网整合，软硬件结合的应急保障技术系统。在统一的地理框架基础上，实现各种应急平台指挥信息的2D、3D地图可视化显示、综合查询分析、可视化调度，并提供高效的辅助决策功能。它具备风险评估、监测监控、预测预警、智能决策、综合协调、应急联动与总结评价等功能。</p>
          </div>
        </div>
        <div class="range">
          <div class="part-title">
            业务应用案例
          </div>
          <el-carousel class="carousel" indicator-position="outside" height="18rem" >
            <el-carousel-item v-for=" index in 6" :key="index">
              <img :src="getImg(`application6-${index}.jpg`)" alt="Carousel Image" style="width: 100%; object-fit: contain;">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Application6",
  metaInfo: {
    title:
      "应急指挥可视化管理_行业三维可视化应用解决方案-上海臻图信息技术有限公司",
    meta: [
      {
        name: "keywords",
        content:
          "应急指挥调度,公安指挥调度,城市应急管理,安全生产应急,应急三维地图,应急GIS"
      },
      {
        name: "description",
        content:
          "可视化应急指挥系统是基于先进GIS地理信息系统、GPS全球定位系统、RS遥感遥测系统、无线通讯系统、电视会议系统等和应急信息资源的多网整合,软硬件结合的应急保障技术系统。在统一的地理框架基础上,实现各种应急平台指挥信息的2D、3D地图可视化显示、综合查询分析、可视化调度,并提供高效的辅助决策功能。它具备风险评估、监测监控、预测预警、智能决策、综合协调、应急联动与总结评价等功能。"
      }
    ]
  },
  data() {
    return {
      bannerData: {
        title: "应急指挥可视化管理",
        p:
          "可视化应急指挥系统是基于先进GIS地理信息系统、GPS全球定位系统、RS遥感遥测系统、无线通讯系统、电视会议系统等和应急信息资源的多网整合，软硬件结合的应急保障技术系统……"
      },
      a: {
        num: "01",
        name: "业务应用范围",
        p:
          "公安指挥调度系统、城市应急管理系统、重大事件安保系统、安全生产应急管理系统等。"
      },
      b: {
        num: "02",
        name: "业务应用概述",
        p:
          "可视化应急指挥系统是基于先进GIS地理信息系统、GPS全球定位系统、RS遥感遥测系统、无线通讯系统、电视会议系统等和应急信息资源的多网整合，软硬件结合的应急保障技术系统。在统一的地理框架基础上，实现各种应急平台指挥信息的2D、3D地图可视化显示、综合查询分析、可视化调度，并提供高效的辅助决策功能。它具备风险评估、监测监控、预测预警、智能决策、综合协调、应急联动与总结评价等功能。"
      },
      c: {
        num: "03",
        name: "业务应用案例"
      }
    };
  },
  methods: {
    getImg(fileName) {
      return require(`@/assets/images/application/${fileName}`);
    }
  },
  mounted: function() {}
};
</script>

<style lang="less" scoped>
//scoped
.bannerTemp {
  background-image: url("../../assets/images/other/header_bg.jpg");
}
.application6 {
  font-size: 0;
  img {
    width: 584px;
    margin-top: 20px;
    &:nth-child(2n + 1) {
      margin-right: 20px;
    }
  }
}
.mobile-application6 {
  display: none;
  width: 100%;
  flex-direction: column;
  font-family: 'Normal';
  .mobile-bannerTemp {
    width: 100%;
    background-image: url("../../assets/images/other/header_bg.jpg");
    background-position: 30%;
    background-size: cover;
    height: 28rem;
  }
  .content {
    width: 100%;
    font-family: 'Normal';
    .range {
      width: 100%;
      box-sizing: border-box;
      padding: 2rem;
      color: #333333;
      .part-title {
        width: 100%;
        text-align: center;
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
      }
      .part-content {
        font-size: 1rem;
        font-weight: 350;
        line-height: 2rem;
        margin-top: 2rem;
        text-indent: 2em;
      }
      .carousel {
        margin-top: 2rem;
      }
    }
  }
}
/deep/.el-carousel__indicators--horizontal  {
  width:100% !important;
  text-align: center !important;
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
/deep/ .el-carousel__button {
  width: 0.5rem;
  height: 0.4rem;
  background: #C1E1FF;
}
/deep/ .case-carousel {
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
@media (max-width: 1024px) {
  .application6 {
    display: none !important;
  }
  .bannerTemp {
    display: none !important;
  }
  .mobile-application6 { 
    display: flex !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/application/application6.vue